import { createContext, useContext } from "react";

// A focus request flowing *down* from the builder mount into the Targeting step
// (F9). The invalid-dates warning's Edit link switches to Targeting and asks it
// to reveal the affected control: the D2D launch-date field, or a specific H2H
// area card. The nonce makes repeated clicks re-fire even when the target is
// unchanged. Mirror of TargetingValidationContext (which also flows down).
export interface TargetingFocusRequest {
  target: "launchDate" | "distributionAreas";
  /** The H2H area to highlight (distributionAreas target); null/absent for D2D. */
  areaId?: string | null;
  nonce: number;
}

// A focus request is a one-shot: a consumer reveals the control then clears it, so
// it can't replay when the Targeting step remounts on a later visit (the request
// lives at the builder mount, which outlives the step — PAD-31560).
export interface TargetingFocusApi {
  request: TargetingFocusRequest | null;
  clear: () => void;
}

export const TargetingFocusContext = createContext<TargetingFocusApi>({ request: null, clear: () => undefined });

export const useTargetingFocus = (): TargetingFocusApi => useContext(TargetingFocusContext);
